import clsx from 'clsx'
import { useTranslation } from 'next-i18next'
import { ChangeEventHandler, FocusEventHandler, ReactNode } from 'react'
type Html5InputType =
  | 'text'
  | 'password'
  | 'email'
  | 'number'
  | 'url'
  | 'tel'
  | 'range'
  | 'color'
  | 'search'
  | 'select'
  | 'textarea'

export type InputOption = {
  name: string
  value: string | number
  selected?: boolean
}

type WifSelectProps = {
  type?: Html5InputType
  error: boolean | undefined
  leftIcon?: ReactNode | undefined
  rightIcon?: ReactNode | undefined
  name?: string
  value: any
  onChange: ChangeEventHandler<HTMLSelectElement>
  onBlur: FocusEventHandler<HTMLSelectElement>
  disabled?: boolean
  options?: InputOption[]
  customInputClass?: string
  selectPlaceholder?: string
}

const WifSelect: React.FC<WifSelectProps> = ({
  error,
  name,
  value,
  onChange,
  onBlur,
  disabled = false,
  options,
  customInputClass,
  selectPlaceholder,
  leftIcon = undefined,
  rightIcon = undefined,
}) => {
  const { t } = useTranslation()
  return (
    <div className='relative'>
      <select
        className={clsx([
          'relative',
          'px-2',
          rightIcon && 'pr-8',
          leftIcon && 'pl-8',
          'w-full',
          'h-[40px]',
          'focus:outline-none',
          'border',
          'rounded-[10px]',
          'text-sm',
          'appearance-none',
          'bg-transparent',
          'flex',
          'items-center',
          'cursor-pointer',
          error ? 'border-error-red' : 'border-[#DEDEDF]',
          disabled ? 'text-silver-gray bg-medium-grey' : 'text-black bg-white',
          customInputClass,
        ])}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        disabled={disabled}
      >
        {selectPlaceholder && (
          <option
            className={clsx(disabled ? 'text-silver-gray bg-medium-grey' : 'text-black bg-white')}
            value=''
            disabled
          >
            {selectPlaceholder}
          </option>
        )}
        {options?.map(({ value: optionValue, name }) => (
          <option className='text-[#303030]' key={name} value={optionValue}>
            {t(name)}
          </option>
        ))}
      </select>

      {leftIcon && (
        <div className={clsx('absolute top-1/2 -translate-y-1/2 flex left-2')}>{leftIcon}</div>
      )}

      {rightIcon && (
        <div className={clsx('absolute top-1/2 -translate-y-1/2 flex right-2')}>{rightIcon}</div>
      )}
    </div>
  )
}
export default WifSelect
